<template>
    <common-panel :panel-data="panelData" :key="activeIndex"/>
</template>

<script>
import DateUtils from "../../../utils/DateUtils";
import CommonPanel from "../../common/panel/CommonPanel";
export default {
  name: "WarningQuery",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        hasTree: false,
        hasTreeToolbar: false,
        noneIcon: 'zy-icon-TXS',
        queryMethod: this.$api.energyMonitor.getAlarmInfo,
        filterForm: [
          {label: '起止日期：', prop: 'start_date', type: 'date', value: DateUtils.getYesterday(), style: 'width: 138px;margin-left: 4px;'},
          {label: '-', prop: 'temp', type: '', style: ''},
          {label: '', prop: 'end_date', type: 'date', value: new Date(), style: 'width: 138px;margin-left: 4px;'},
          {
            label: '告警类型：', prop: 'alarmType', type: 'select', value: -1, style: 'width: 120px;',
            props: {value: 'value', label: 'label'},
            options: [{value: -1, label: '所有'}, {value: 0, label: '越限恢复'}, {value: 1, label: '越限'}, {value: 2, label: '网关上下线'}
            ]
          },
          {
            label: '告警状态：', prop: 'status', type: 'select', value: -1, style: 'width: 120px;margin-right: 36px;',
            props: {value: 'value', label: 'label'},
            options: [{value: -1, label: '所有'}, {value: 0, label: '未确认'}, {value: 1, label: '已确认'}
            ]
          }
        ],
        buttons: [
          {label: '确认告警', icon: 'zy-icon-confirm-circle', type: 'Abnorm', handleIndex: 0, disabledKey: 'flag'}
        ],
        methods: {
          query_id: 'id',
          Abnorm: this.$api.energyMonitor.updateAlarmStatus
        },
        tableCheck: true,
        tableTitle: '告警列表',
        tableProps: [
          {prop: "installAddr", label: "区域名称"},
          {prop: "devName", label: "回路名称"},
          {prop: "ercName", label: "告警事件描述"},
          {prop: "level", label: "告警级别"},
          {prop: "dataTime", label: "发生时间"},
          {prop: "data", label: "当前值"},
          {prop: "limit", label: "阀值"},
          {prop: "status", label: "当前状态"}
        ]
      }
    }
  }
}
</script>

<style scoped>
  .error-warning{
    width: 100%;
    height: 100%;
  }
  .el-menu{
    background: white;
  }
  .el-menu .el-menu-item{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/WarningManage/WarningQuery.vue